import { render, staticRenderFns } from "./companydetail.vue?vue&type=template&id=6191a8b5&scoped=true&"
import script from "./companydetail.vue?vue&type=script&lang=js&"
export * from "./companydetail.vue?vue&type=script&lang=js&"
import style0 from "./companydetail.vue?vue&type=style&index=0&id=6191a8b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6191a8b5",
  null
  
)

export default component.exports